import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FONT_FAMILIES, FONT_SIZES, COLOR } from 'config';
import { rem } from 'polished';

import styled from 'styled-components';

const NavSideMenu = styled.div`
  @media (max-width: 831px) {
    height: 50px;
    width: 100%;
    background-color: white;
    border-bottom: 1px solid ${COLOR.borderGrey} !important;
    margin-bottom: 24px;
  }
`;

const Sidemenu = styled.div`
  display: flex;
  flex-direction: column;

  position: -webkit-sticky;
  position: sticky;
  top: 0;
  
  @media (max-width: 831px) {
    flex-direction: row;
    justify-content: center;
    text-align: center;
    padding-bottom: 50px;
  }
`;

const Link = styled.a`
  font-size: ${rem(FONT_SIZES[4])};
  font-family: ${FONT_FAMILIES.sans};
  color: ${COLOR.base} !important;
  text-decoration: none;
  margin-bottom: 12px;
  cursor: pointer;
  padding: 12px 16px;
  border-radius: 4px;
  text-transform: capitalize;

  &:hover {
    background-color: #F8F8F8;
    color: ${COLOR.dark} !important;

    @media (max-width: 831px) {
      background-color: #FFFFFF;
    }

  }
`;

const CxSideMenu = () => (
  <NavSideMenu>
    <Sidemenu>
      <Link href="/cx/home">
        <FormattedMessage id="cxs.cx.title" />
      </Link>
      <Link href="/cx/docs">
        <FormattedMessage id="cxs.docs.title" />
      </Link>
      <Link href="/cx/example">
        <FormattedMessage id="cxs.example.title" />
      </Link>
      <Link href="/cx/about">
        <FormattedMessage id="cxs.about.title" />
      </Link>
      <Link href="https://github.com/skycoin/cx" target="_blank" rel="noopener noreferrer">
        <FormattedMessage id="cxs.github.title" />
      </Link>
    </Sidemenu>
  </NavSideMenu>
);

CxSideMenu.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(CxSideMenu);



// WEBPACK FOOTER //
// ./src/components/CXs/components/CxSideMenu/CxSideMenu.js